import { prop, pick } from 'ramda';
import { useMemo } from 'react';
import { useLiveGameConfig } from '@theme/js/hooks/games';
import { TGamesGridLayoutSize } from '@theme/js/hooks/games/types';
import { useGameConfigurationSelector, useDeviceSelector, useUserSelector } from '@core/js/store/hooks';

import * as helpers from './helpers';
import * as Types from '../../types';
import { TGameRatio } from '@core/js/components/main/GamesGrid/types';

export const useGetGameConfiguration = ({ gameCode, ratio, size }: {
    gameCode: string;
    ratio: TGameRatio;
    size: TGamesGridLayoutSize;
}): Types.TGameConfiguration | null => {
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const formFactor = useDeviceSelector(prop('formFactor'));
    const { games, liveGameTileLayout } = useGameConfigurationSelector(pick(['games', 'liveGameTileLayout']));
    const liveTable = useLiveGameConfig(games[gameCode]?.liveLaunchAlias);

    return useMemo(() => {
        const game = games[gameCode];

        if (!game) {
            return null;
        }

        const gameImage = helpers.getGameImage({ game, formFactor, isLoggedIn, size, ratio }) || '';

        if (!liveTable) {
            return {
                ...game,
                isLiveGame: false,
                gameImage: [gameImage].filter(Boolean)
            };
        }

        const liveImage = liveGameTileLayout?.isLiveImageEnabled ? liveTable.dynamicImageUrl : '';

        return {
            ...game,
            isLiveGame: true,
            liveConfiguration: liveTable,
            gameImage: [liveImage, gameImage].filter(Boolean)
        };
    }, [formFactor, gameCode, games, isLoggedIn, liveTable, ratio, size, liveGameTileLayout]);
};
